<div class="container-fluid">
  <div class="row">
    <div class="col-4">
      <h4>Verlauf - {{forms?.[0]?.name}}</h4>
      @if (!forms) {
        <rbb-loader/>
      }
      <div class="list-group list-group-flush button-adde  p-1 pt-0 border-none">
        @for (form of forms; track form.id; let i = $index) {
          <a (click)="selectedForm = i"
             (keydown.enter)="selectedForm = i"
             (keydown.space)="selectedForm = i"
             tabindex="0"
             [ngClass]="{'active' : selectedForm === i}"
             class="list-group-item list-group-item-action pointer">
            <div class="fw-bold">
              @if (form.visible) {
                <i class="fa-regular fa-eye text-success pe-2"></i>
              } @else {
                <i class="fa-regular fa-eye-slash text-danger pe-2"></i>
              }
              {{form.timestamp | date:'dd.MM.yyyy HH:mm'}} -
              {{form.createdByFirstName}} {{form.createdByLastName}}
              @if (form.visible && form.approvalDataProtectionOfficerAt) {
                <i class="fa-solid fa-user-check text-success ps-2"></i>
              }
            </div>
            <app-form-diff [form]="form" [oldForm]="forms?.[i + 1]"/>
            @if (i) {
              <button class="btn btn-sm btn-primary" (click)="selectedForm = i; openCopyForm();">Neue Version mit diesen Felder erstellen.</button>
            }
          </a>
        }
      </div>
    </div>
    <div class="col-8">
      @if (forms && selectedForm !== undefined) {
        <app-form [form]="forms[selectedForm]" [isPreview]="true" [lastApproved]="forms[selectedForm + 1]"/>
      }
    </div>
  </div>
</div>

<ng-template #ngModalCopy>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      Neue Formularversion erstellen
    </h5>
  </div>
  <div class="modal-body p-3">
    @if (forms && selectedForm) {
      Wollen Sie wirklich eine neue Formularversion erstellen? Dabei werden die allgemeinen Daten aus der letzten Version verwendet, sowie die {{forms[selectedForm].fields?.length}} Felder aus der Formularversion vom {{forms[selectedForm].timestamp | date: 'dd.MM.yyyy HH:mm'}}.
    }
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="copyForm()" class="btn btn-primary btn-sm" type="button"><i
      class="far fa-save" aria-hidden="true"></i>&ensp;Erstellen
    </button>
    <button (click)="closeCopyForm()" class="btn btn-secondary btn-sm" type="button">
      <i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen
    </button>
  </div>
</ng-template>
